import RestClient from './RestClient'

const ENTRY_POINT = '/admin'

export default class AdminService {
  restClient: RestClient
  constructor(restClient: RestClient) {
    this.restClient = restClient
  }

  getAdminSetting(): Promise<IAdminSetting> {
    return this.restClient.get(ENTRY_POINT + '/setting')
  }

  setAdminSetting(setting: IAdminSetting): Promise<IAdminSetting> {
    return this.restClient.post(ENTRY_POINT + '/setting', setting)
  }

  getRollRequest(rollRequestId: number): Promise<IRollRequest> {
    return this.restClient.post(ENTRY_POINT + '/get-roll-request', undefined, {rollRequestId: rollRequestId})
  }

  doRollRequest(rollRequest: IRollRequest): Promise<IRollResult> {
    return this.restClient.post(ENTRY_POINT + '/do-roll-request', rollRequest)
  }

  setAbout(about: string): Promise<string> {
    return this.restClient.post(ENTRY_POINT + '/about', {}, {about: about})
  }

  setGuideline(guideline: string): Promise<string> {
    return this.restClient.post(ENTRY_POINT + '/guideline', {}, {guideline: guideline})
  }

  getAbout(): Promise<string> {
    return this.restClient.get(ENTRY_POINT + '/about')
  }

  getGuideline(): Promise<string> {
    return this.restClient.get(ENTRY_POINT + '/guideline')
  }

  getRollRequestTable(rollRequestTableInfo: IRollRequestTableInfo): Promise<IPageable<IRollRequest>> {
    return this.restClient.post(ENTRY_POINT + '/history-roll-request', rollRequestTableInfo)
  }

  authPhone(): Promise<Boolean> {
    return this.restClient.get(ENTRY_POINT + '/authPhone')
  }

  getDepRequestInfo(depRequestId: number): Promise<IDepositRequest> {
    return this.restClient.post(ENTRY_POINT + '/get-dep-request', undefined,
                                {depRequestId: depRequestId})
  }

  approveDeptRequest(approveDepRequestInfo: IApproveDepRequestInfo): Promise<IDepositRequest> {
    return this.restClient.post(ENTRY_POINT + '/approve-dep-request', approveDepRequestInfo)
  }

  getHistoryTransacion(transactionSearchInfo: ITransactionSearchInfo): Promise<IPageable<ITransaction>> {
    return this.restClient.post(ENTRY_POINT + '/history-transaction', transactionSearchInfo)
  }

  searchUser(userSearchInfo: IUserSearchInfo): Promise<IPageable<IUser>> {
    return this.restClient.post(ENTRY_POINT + '/search-user', userSearchInfo)
  }

  editUser(userEditInfo: IUserEditInfo): Promise<IUser> {
    return this.restClient.post(ENTRY_POINT + '/edit-user', userEditInfo)
  }

  getMarqueeText(): Promise<string> {
    return this.restClient.get(ENTRY_POINT + '/marquee')
  }

  setMarqueeText(marquee: string): Promise<string> {
    return this.restClient.post(ENTRY_POINT + '/marquee', undefined, {marquee: marquee})
  }

  getCookieExchange(): Promise<string> {
    return this.restClient.get(ENTRY_POINT + '/cookie-exchange')
  }

  setCookieExchange(cookie: string): Promise<string> {
    return this.restClient.post(ENTRY_POINT + '/cookie-exchange', undefined, {cookie: cookie})
  }

  getKeywordsExchange(): Promise<string> {
    return this.restClient.get(ENTRY_POINT + '/keywords-exchange')
  }

  setKeywordsExchange(keywords: string): Promise<string> {
    return this.restClient.post(ENTRY_POINT + '/keywords-exchange', undefined, {keywords: keywords})
  }

  getKeywordsExcept(): Promise<string> {
    return this.restClient.get(ENTRY_POINT + '/keywords-except')
  }

  setKeywordsExcept(keywords: string): Promise<string> {
    return this.restClient.post(ENTRY_POINT + '/keywords-except', undefined, {keywords: keywords})
  }

  adminRoll(rollRequest: IRollRequestInfo): Promise<IRollResult> {
    return this.restClient.post(ENTRY_POINT + '/admin-roll', rollRequest)
  }

  resetRank(): Promise<boolean> {
    return this.restClient.get(ENTRY_POINT + '/reset-rank')
  }

  getAllIp(getIpInfo: ISearchIp): Promise<IPageable<IBannedIp>> {
    return this.restClient.post(ENTRY_POINT + '/get-all-ip', getIpInfo)
  }

  unbanIp(ip: string): Promise<IBannedIp> {
    return this.restClient.post(ENTRY_POINT + '/unbanned', undefined, {ip: ip})
  }

  banIp(ip: string): Promise<IBannedIp> {
    return this.restClient.post(ENTRY_POINT + '/ban-ip', undefined, {ip : ip})
  }

  getTodayRevenue(): Promise<number> {
    return this.restClient.get(ENTRY_POINT + '/revenue-today')
  }

  getThisMonthRevenue(): Promise<number> {
    return this.restClient.get(ENTRY_POINT + '/revenue-month')
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/AdminService.ts